import { canvasSlice } from '@/entities/canvas';
import { collectionSlice } from '@/entities/collection';
import { authSlice } from '@/entities/session';
import { collectionApi, posApi } from '@/shared/api';
import { gatewayApi } from '@/shared/api/gateway-api';
import { combineReducers } from '@reduxjs/toolkit';

export const rootReducer = combineReducers({
  [authSlice.name]: authSlice.reducer,
  [collectionSlice.name]: collectionSlice.reducer,
  [canvasSlice.name]: canvasSlice.reducer,
  [collectionApi.reducerPath]: collectionApi.reducer,
  [posApi.reducerPath]: posApi.reducer,
  [gatewayApi.reducerPath]: gatewayApi.reducer,
});
